import {movedSvg as Icon__small__movedSvg} from '../Icon__small/Icon__small--moved.js';

export var moved = {
  name: 'moved',
  category: 'icon',
  colorable: true,
  svg: Icon__small__movedSvg,
};
